<script>
import BaseChart from '@/components/dashboard/charts/BaseChart'

export default BaseChart.extend({

  data () {
    return {
      type: 'bar',
      chartOptions: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },

  computed: {
    values () {
      return Object.values(this.$store.getters.barGraphData)
    },

    labels () {
      return Object.values(this.$store.getters.barGraphLabels)
    },

    chartData () {
      return {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: [{
            label: '# of participants',
            data: this.values,
            backgroundColor: this.getColors('transparent', this.values.length),
            borderColor: this.getColors('solid', this.values.length),
            borderWidth: 1
          }]
        },
        options: this.chartOptions
      }
    }
  },

  beforeDestroy () {
    /** Remove any event listeners */
    this.eventHub.$off('progBucketsUpdated')
    this.eventHub.$off('groupCourseCohortFilterUpdated')
    this.eventHub.$off('gccFilterUpdated')
  },

  mounted () {
    /** Listen for when Progress Buckets are updated */
    this.eventHub.$on(['progBucketsUpdated', 'groupCourseCohortFilterUpdated', 'gccFilterUpdated'], this.refresh)

    this.errorCheck()

    this.render(this.chartData)
  },

  methods: {
    errorCheck () {
      if (
        this.$store.state.selectedGroup.length === 0 ||
        this.$store.state.selectedGroupCourses.length === 0 ||
        this.$store.state.selectedCohorts.length === 0
      ) {
        this.errorBag = {
          status: 'danger',
          message: 'Please select a min. of 1 each of Groups, Courses and Cohorts.'
        }
      } else {
        this.errorBag = {
          status: '',
          message: ''
        }
      }
    }
  }

})
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/BarChart.vue